import { inferLanguageFromNavigator } from './hook';

export const inferLanguage = () => Promise.resolve(inferLanguageFromNavigator());
